import { Figure } from '@/components/Figure'
import { getExercise } from '@/data/exercises'
import type { Movement, Phase } from '@/domain/workout'
import styles from './workout.module.css'

/** Los movimientos que se enseñan antes de arrancar, según el formato. */
function movementsOf(phase: Phase): readonly Movement[] {
  if (phase.kind === 'amrap') return phase.movements
  if (phase.kind === 'afap') return phase.blocks
  return []
}

/**
 * Pantalla previa al bloque: qué toca, cuántas repeticiones y cómo se hace.
 * Da tiempo a colocarse antes de que arranque el reloj.
 */
export function BriefingView({ phase }: { phase: Phase }) {
  const movements = movementsOf(phase)

  return (
    <div className={styles.briefing}>
      <div className={styles.briefingHead}>
        <b>{phase.name}</b>
        <span>{phase.briefing}</span>
      </div>
      <div className={styles.briefingList}>
        {movements.map((movement, index) => {
          const exercise = getExercise(movement.exerciseId)
          return (
            <div key={`${movement.exerciseId}-${index}`} className={styles.card}>
              <div className={styles.cardFigure}>
                <Figure exerciseId={movement.exerciseId} />
              </div>
              <div className={styles.cardText}>
                <div className={styles.cardReps}>{movement.reps} reps</div>
                <div className={styles.cardName}>{exercise.name}</div>
                <div className={styles.cardEs}>{exercise.nameEs}</div>
                <div className={styles.cardCue}>{exercise.cue}</div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
